export default __webpack_public_path__ + "static/media/light-bulb.fc90eb9e.png";